import { createUploadLink } from "apollo-upload-client"
import { graphql } from "gatsby"
import React from "react"

import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client"
import GravityFormsForm from "@blocks/GravityFormsForm/GravityFormsForm"

const HANDLER_URI =
  process.env.GATSBY_WP_GRAPHQL || `https://almatalentstg.wpengine.com/graphql`

const client = new ApolloClient({
  link: createUploadLink({
    uri: HANDLER_URI,
  }),
  cache: new InMemoryCache(),
})

const GravityFormsFormWrapper = ({ formId }) => {
  return (
    <ApolloProvider client={client}>
      <GravityFormsForm formId={formId} />
    </ApolloProvider>
  )
}

export const query = graphql`
  fragment GfForm on WpBlockGravityFormsForm {
    __typename
    formId
  }
`
export default GravityFormsFormWrapper
